import PropTypes from 'prop-types';

export const InputPropTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    errorMessage: PropTypes.string,
    infoText: PropTypes.string,
    captionText: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(['outlined', 'filled']),
    fullWidth: PropTypes.bool,
    size: PropTypes.oneOf(['default', 'small']),
    labelInfoText: PropTypes.string,
    addClassName: PropTypes.string,
    
    // Icon props
    prefixIcon: PropTypes.element,
    suffixIcon: PropTypes.element,
    
    // Dropdown props
    prefixDropdown: PropTypes.bool,
    prefixDropdownOption: PropTypes.arrayOf(PropTypes.object),
    prefixDropdownValue: PropTypes.string,
    prefixDropdownSelectedOption: PropTypes.object,
    prefixDropdownOnAdd: PropTypes.func,
    suffixDropdown: PropTypes.bool,
    suffixDropdownOption: PropTypes.arrayOf(PropTypes.object),
    suffixDropdownValue: PropTypes.string,
    suffixDropdownSelectedOption: PropTypes.object,
    suffixDropdownOnAdd: PropTypes.func,
    
    // Chip props
    chipInputMultiple: PropTypes.bool,
    chipValues: PropTypes.arrayOf(PropTypes.object),
    setChipValues: PropTypes.func,
    allowChipModify: PropTypes.func,
    onClearChips: PropTypes.func,
    
    // Form props
    onBlur: PropTypes.func,
    disableClear: PropTypes.bool,
    register: PropTypes.func,
    pipeText: PropTypes.string,
    keyPress: PropTypes.func,
    setValue: PropTypes.func,
    onCancel: PropTypes.func,
    labelInfoIcon: PropTypes.bool
};
